import React from 'react';

const LoadingSpinner = ({ message = 'جاري التحميل...' }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '200px',
      gap: '1rem',
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: '3px solid #dde4ee',
        borderTopColor: '#1d4ed8',
        animation: 'spin 0.75s linear infinite',
      }} />
      <p style={{
        margin: 0,
        color: 'var(--text-muted, #64748b)',
        fontSize: '0.875rem',
        fontWeight: 600,
        fontFamily: 'inherit',
      }}>{message}</p>
      <style>{`@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`}</style>
    </div>
  );
};

export default LoadingSpinner;
